export default __webpack_public_path__ + "static/media/touch pads - active.2d7e2c66.svg";